import { BaseCustomElement } from "brut-js"

class FormDisable extends BaseCustomElement {
  static tagName = "cc-form-disable"

  static observedAttributes = [
    "show-warnings",
    "disable-when-checked",
    "enable-when-checked",
    "exclude",
  ]

  #whenCheckedDisableElementId   = null
  #whenCheckedEnableElementId    = null
  #excludeFromBehaviorElementIds = []

  #disabledAlreadyAttribute = "FormDisable-alreadyDisabled"
  #disabledManagedByThisAttribute = "FormDisable-managingDisabled"

  disableWhenCheckedChangedCallback({newValue}) {
    this.#whenCheckedDisableElementId = newValue
  }

  enableWhenCheckedChangedCallback({newValue}) {
    this.#whenCheckedEnableElementId = newValue
  }

  excludeChangedCallback({newValue}) {
    this.#excludeFromBehaviorElementIds = (newValue || "").split(/\s+/)
  }

  update() {
    const whenCheckedEnableElement  = this.querySelector(`#${this.#whenCheckedEnableElementId}`)
    const whenCheckedDisableElement = this.querySelector(`#${this.#whenCheckedDisableElementId}`)

    if (whenCheckedDisableElement) {
      whenCheckedDisableElement.addEventListener("change", this.#disableOnClickListener)
      if (whenCheckedDisableElement.checked) {
        this.#disable(whenCheckedDisableElement)
      }
    }
    else if (this.#whenCheckedDisableElementId) {
      this.logger.info("No element inside this one with id '%s' - no disabling will happen",this.#whenCheckedDisableElementId)
    }
    if (whenCheckedEnableElement) {
      whenCheckedEnableElement.addEventListener("change", this.#enableOnClickListener)
    }
    else if (this.#whenCheckedEnableElementId) {
      this.logger.info("No element inside this one with id '%s' - no enabling will happen",this.#whenCheckedEnableElementId)
    }
    this.#reEnableExcludedElements()
  }

  #disableOnClickListener = (event) => this.#disable(event.target)
  #enableOnClickListener  = (event) => this.#enable(event.target)

  #disable(eventTarget) {
    this.dispatchEvent(new Event("disable", { cancelable: false, bubbles: true }))
    const form = this.#locateFormIfChecked(eventTarget)
    if (!form) {
      return
    }

    this.#eachDisablableElement(form, (element) => {
      const managingDisabled = element.getAttribute(this.#disabledManagedByThisAttribute) === ""
      if (element.disabled && !managingDisabled) {
        element.setAttribute(this.#disabledAlreadyAttribute,"")
      }
      else {
        element.setAttribute("disabled","")
        element.setAttribute(this.#disabledManagedByThisAttribute,"")
      }
    })
  }


  #enable(eventTarget) {
    this.dispatchEvent(new Event("enable", { cancelable: false, bubbles: true }))
    const form = this.#locateFormIfChecked(eventTarget)
    if (!form) {
      return
    }
    this.#eachDisablableElement(form, (element) => {
      if (element.getAttribute(this.#disabledAlreadyAttribute) === "") {
        element.removeAttribute(this.#disabledAlreadyAttribute)
      }
      else {
        element.removeAttribute("disabled")
      }
    })
  }

  #reEnableExcludedElements() {
    this.#excludeFromBehaviorElementIds.forEach( (id) => {
      const element = document.getElementById(id)
      if (!element) {
        return
      }
      if (element.getAttribute(this.#disabledManagedByThisAttribute) === "") {
        element.removeAttribute("disabled")
        element.removeAttribute(this.#disabledManagedByThisAttribute)
        element.removeAttribute(this.#disabledAlreadyAttribute)
      }
    })
  }

  #locateFormIfChecked(eventTarget) {
    if (!eventTarget.checked) {
      return
    }
    const form = eventTarget.form
    if (!form) {
      this.logger.info("Element %o had no form, so nothing to enable",eventTarget)
      return
    }
    return form
  }

  #eachDisablableElement(form, f) {
    let foundAtLeastOneElement = false
    Array.from(form.elements).forEach( (element) => {
      if (this.contains(element)) {
        return
      }
      if (this.#excludeFromBehaviorElementIds.indexOf(element.id) != -1) {
        return
      }
      if (element.type == "hidden") {
        return
      }
      foundAtLeastOneElement = true
      f(element)
    })
    if (!foundAtLeastOneElement) {
      this.logger.info("Did not find any elements inside the form - nothing will happen")
    }
  }
}
export default FormDisable
